import { useEffect } from "react";

const SITE_URL = "https://www.dmbpartners.fr";

function upsertMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

export function breadcrumbTrail(items) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((it, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: it.name,
            item: `${SITE_URL}${it.path}`,
        })),
    };
}

/**
 * Méta SEO par route : title, description, canonical, OG, Twitter et JSON-LD
 * spécifique. Sans dépendance externe ; capturé par le prérendu (react-snap).
 */
export default function Seo({ title, description, path = "/", robots, jsonLd }) {
    const json = jsonLd ? JSON.stringify(jsonLd) : "";

    useEffect(() => {
        document.title = title;
        upsertMeta("name", "description", description);
        if (robots) upsertMeta("name", "robots", robots);

        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", `${SITE_URL}${path}`);

        upsertMeta("property", "og:title", title);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:url", `${SITE_URL}${path}`);
        upsertMeta("name", "twitter:title", title);
        upsertMeta("name", "twitter:description", description);

        const id = "route-jsonld";
        let script = document.getElementById(id);
        if (json) {
            if (!script) {
                script = document.createElement("script");
                script.type = "application/ld+json";
                script.id = id;
                document.head.appendChild(script);
            }
            script.textContent = json;
        } else if (script) {
            script.remove();
        }
    }, [title, description, path, robots, json]);

    return null;
}
